import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncSpotifyToYoutubeMusic() {
    return (
        <GuidesPage
            seoData={seoContent.syncSpotifyToYoutubeMusic}
            sections={<PairSyncGuideContent sourceKey="spotify" destKey="youtubeMusic" />}
        />
    );
}
